import axios        from "axios";
import {url_path}   from "./paths";

export default {
    state: {
        layers: [ ],
        current_layer:{
            layer:{
                id: 0,
                name: ''
            }
        },
        insertedLayer: 0,
        backLayer: 0
    },
    mutations: {
        setLayersList (state, payload) {
            state.layers = payload;
        },
        setCurrentLayer (state, payload) {
            state.current_layer = payload;
        },
        clearCurrentLayer (state) {
            state.current_layer = {
                layer:{
                    id: 0,
                    name: ''
                }
            }
        },
        insertLayer(state, payload) {
            state.insertedLayer = payload.inserted_layer_id;
        },
        insertBackLayer(state, id){
            state.backLayer = id;
        }
    },
    actions: {
        async getLayers ({commit}, hashid) {
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.get(url_path.url_layers_list + hashid);

                if (response.data.status == url_path.response_status_ok){
                    commit('setLayersList', response.data.data);
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async getCurrentLayer ({commit}, {hashid, id, show_geo, low_quality, pypreload}) {
            commit('clearError');
            commit('setLoading', true);
            let add_geo = '?low_quality=' + low_quality;
            add_geo += '&pypreload=' + pypreload;
            if (show_geo) add_geo += '&show_geo=1';
            try {
                await axios.get(url_path.url_layers_view + hashid + '/' + id + add_geo)
                .then((response) => {

                    if (response.data.status == url_path.response_status_ok){
                        response.data.data.documents = [];
                        for (const [key, value] of Object.entries(response.data.data.info)) {
                            response.data.data.documents.push(value);
                        }
                        commit('setCurrentLayer', response.data.data);
                        commit('setLoading', false);
                    }
                    else {
                        commit('setLoading', false);
                        commit('setError', response.data.error_message);
                    }

                });
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        clearCurrentLayer ({commit}) {
            commit('clearCurrentLayer');
        },
        async addNewLayer ({commit}, {name, hashid}){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.get(url_path.url_layers_add + '?name=' + name + '&project_hashid=' + hashid);
                if (response.data.status == url_path.response_status_ok){
                    commit('insertLayer', response.data.data);
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async deleteLayer ({commit}, id){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.get(url_path.url_layers_delete + id);
                if (response.data.status == url_path.response_status_ok){
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        async editNewLayer ({commit}, {name, hashid, id}){
            commit('clearError');
            commit('setLoading', true);
            try {
                const response = await axios.post(url_path.url_layers_edit + id, {name: name, project_hashid: hashid});
                if (response.data.status == url_path.response_status_ok){
                    commit('setLoading', false);
                }
                else {
                    commit('setLoading', false);
                    commit('setError', response.data.error_message);
                }
            }
            catch (error) {
                if (error.response.status == 401){
                    commit('setLoading', false);
                    commit('setError', 'Your session has expired. Please login again.');
                    commit('setUnAuth');
                }
                else{
                    commit('setLoading', false);
                    commit('setError', error.message);
                }
                throw error
            }
        },
        insertBackLayer ({commit}, id) {
            commit('insertBackLayer', id);
        },
    },
    getters: {
        layers (state){
            return state.layers;
        },
        currentLayer (state) {
            return state.current_layer;
        },
        inserted_layer (state) {
            return state.insertedLayer;
        },
        back_layer (state) {
            return state.backLayer;
        }
    }
}
